import { AfterViewInit, Directive, ElementRef, Injector, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudItemComponent, UserStorage, requiredValidator } from '@scisys-uim/uim-common';
import { AssetsUser, REF_CODE_TYPE, RefCode, RefCodeKey } from 'assets-model';
import { RefCodeService } from 'assets-service';


@Directive()
export abstract class RefCodeItemComponentBase extends CrudItemComponent<RefCode, RefCodeKey> implements OnInit, AfterViewInit {

  protected systemConfig: any;
  
  public form: FormGroup;
  

  get eAssetsUser(): AssetsUser {
    return AssetsUser.assignAs(this.userDetails);
  }

  constructor(protected refCodeService: RefCodeService,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(REF_CODE_TYPE, fb, elementRef, router, route, userStorage, dialog, refCodeService, injector, snackbar);
  }

  createNewItem() {
    return new RefCode();
  }
  
  createForm(): FormGroup {
    return this.fb.group({
      code: [null, [requiredValidator,]],
      domain: [null, [requiredValidator,]],
      meaning: [null, []],
      val1: [null, []],
      val2: [null, []]
    });
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
  }
  
  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
  }
  
  protected initSystemConfig(config: any): any {
    config = config || {};
    return config;
  }

  protected initConfig(config: any) {
    super.initConfig(config);
    this.systemConfig = this.initSystemConfig(config);
  }
  
  setDefaults() {
    if (!this.readOnly && this.createMode) {
      // re-trigger updating drop-downs.
      this.itemSet();
    }
    this.setDefaultDisabledFields();
  }

  setDefaultDisabledFields() {
    if (!this.form) {
      return;
    }
    if (!this.createMode) {
      this.code?.disable();
      this.domain?.disable();
    }
  }
  
  codeChanging(value: string, unsetDependents: boolean = true) {}
  
  codeChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.codeChangedByUser(value, unsetDependents);
    }
  }  
  
  codeChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  domainChanging(value: string, unsetDependents: boolean = true) {}
  
  domainChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.domainChangedByUser(value, unsetDependents);
    }
  }  
  
  domainChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  meaningChanging(value: string, unsetDependents: boolean = true) {}
  
  meaningChanged(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.meaningChangedByUser(value, unsetDependents);
    }
  }  
  
  meaningChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  val1Changing(value: string, unsetDependents: boolean = true) {}
  
  val1Changed(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.val1ChangedByUser(value, unsetDependents);
    }
  }  
  
  val1ChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  
  val2Changing(value: string, unsetDependents: boolean = true) {}
  
  val2Changed(value: string, unsetDependents: boolean = true) {
    const isUserChangeAfterPageLoad: boolean = !this.readOnly && this.isLifecycleStateItemSetComplete();
    if (isUserChangeAfterPageLoad) {
      this.val2ChangedByUser(value, unsetDependents);
    }
  }  
  
  val2ChangedByUser(value: string, unsetDependents: boolean = true) {
  }
  

  control(name: string) {
    return this.form ? this.form.get(name) : null;
  }

  get code() {
    return this.control('code');
  }
  
  get domain() {
    return this.control('domain');
  }
  
  get meaning() {
    return this.control('meaning');
  }
  
  get val1() {
    return this.control('val1');
  }
  
  get val2() {
    return this.control('val2');
  }
  
}





